import { all, call, fork, put, takeLatest } from "redux-saga/effects";

import { Creators as Actions, Types } from "ducks/Pesquisar";
import { Creators as ActionsGeral } from "ducks/Geral";

import api from "../api/api";
import notify from 'utils/modern_notify';

const pesqNotasReq = async (filtros) =>
    api
        .post(`/api/pesquisar`, filtros)
        .then((dados) => dados)
        .catch((error) => error);

const enviarEmailReq = async (dados) =>
    api
        .post(`/api/comprovacao/email`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const buscarDestReq = async (dados) =>
    api
        .get(`/api/pesquisa/dest`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const buscarTranspReq = async (dados) =>
    api
        .get(`/api/pesquisa/empresa`, dados)
        .then((dados) => dados)
        .catch((error) => error);

function* enviarEmail({ payload }) {
    const {
        nome_remetente,
        // remetente,
        texto,
        destinatario,
        assunto,
        notas,
        grupo_empresa,
    } = payload;

    let searchMessage = "";

    if (
        nome_remetente === "" ||
        // remetente === "" ||
        destinatario.lenght === 0 ||
        assunto === "" ||
        grupo_empresa === ""
    ) {
        notify(`Todos os campos são obrigatórios, preencha corretamente todos eles.`,1)
    } else {
        try {
            const response = yield call(enviarEmailReq, {
                remetente: nome_remetente,
                // remetente,
                conteudo: texto,
                destinatarios: destinatario,
                assunto,
                ars: notas,
                grupo_emp: grupo_empresa,
                // tipo: "nota",
            });
            if (!response.ok) return;

            if (response.data.status) {
                // yield put(
                //     ActionsGeral.setMensagem({
                //         mensagem: `E-mail enviado com sucesso!`,
                //         mostrar: true,
                //     })
                // );
                notify("E-mail enviado com sucesso !",2)
            } else {
                if (
                    Object.prototype.hasOwnProperty.call(response.data, "error")
                ) {
                    switch (response.data.error) {
                        default:
                            searchMessage = `Ocorreu um erro ao enviar e-mail ${response.data.error}`;
                            break;
                    }
                } else {
                    searchMessage =
                        "Ocorreu um erro de servidor ao enviar e-mail";
                }

                notify(searchMessage)
            }
        } catch (error) {
            notify(`Erro ao enviar email [ ${error.message} ]`)
        }
    }
}

function* pesqNotas({ payload }) {
    const { data } = payload;

    let searchMessage = "";

    try {
        const response = yield call(pesqNotasReq, data);

        if (response.ok) {
            if (response.data) {
                const responseData = response.data;

                if (!responseData) {
                    searchMessage = "Não foi encontrado nenhum dado";
                    notify(searchMessage,1)
                    yield put(Actions.setLoadPesq(false));
                } else {
                    if (data.skip === 0) {
                        if (response.data.dados.length > 0) {
                            yield put(Actions.pesqNotasSuces(responseData));
                            yield put(Actions.setLoadPesq(false));

                            searchMessage = "Pesquisa feita com sucesso!";
                            notify(searchMessage,2)
                        } else {
                            searchMessage = "Não há dados para ser carregados";
                            notify(searchMessage,1)

                            yield put(Actions.pesqNotasSuces(responseData));
                            yield put(Actions.setLoadPesq(false));
                        }
                    } else {
                        yield put(Actions.setSkip(responseData));
                        yield put(Actions.setLoadSkipPesq(false));
                    }
                }
            } else {
                searchMessage = "Erro ao fazer pesquisa";
                notify(searchMessage)
                yield put(Actions.setLoadSkipPesq(false));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                if (response.data.error) {
                    searchMessage = `${response.data.error}`;
                }
            } else {
                searchMessage = "Ocorreu um erro de servidor ao fazer pesquisa";
            }

            notify(searchMessage)
            yield put(Actions.setLoadPesq(false));
        }
    } catch (error) {
        notify(`Erro ao pesquisar [ ${error.message} ]`)
        yield put(Actions.setLoadPesq(false));
    }
}

function* buscarDest({ payload }) {
    const { cnpj, visao } = payload;

    let searchMessage = "";

    try {
        const response = yield call(buscarDestReq, { cnpj, visao });

        if (response.ok) {
            if (response.data.resultado) {
                if (typeof response.data.valor === "object") {
                    if (response.data.valor.length > 0) {
                        yield put(
                            Actions.buscarDestSucess(response.data.valor)
                        );
                    } else {
                        yield put(Actions.buscarDestSucess([]));
                    }
                } else {
                    yield put(Actions.buscarDestSucess([]));
                }
            } else {
                yield put(Actions.buscarDestSucess([]));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        searchMessage = `Ocorreu um erro ${response.data.error}`;
                        break;
                }
            } else {
                searchMessage = "Ocorreu um erro interno. Tente novamente!";
            }

            notify(searchMessage || "Erro ao buscar destinatários.")
        }
    } catch (error) {
        notify(`Erro ao buscar destinatários [${error.message}]`)
    }
}

function* buscarTransp({ payload }) {
    const { cnpj, visao } = payload;

    let searchMessage = "";

    try {
        const response = yield call(buscarTranspReq, { cnpj, visao });

        if (response.ok) {
            if (response.data.resultado) {
                yield put(Actions.buscarTranspSucess(response.data.valor));
            } else {
                yield put(Actions.buscarTranspSucess([]));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        searchMessage = `Ocorreu um erro ${response.data.error}`;
                        break;
                }
            } else {
                searchMessage = "Ocorreu um erro interno.Tente novamente";
            }

            notify(searchMessage || "Erro ao buscar transportadoras.")
        }
    } catch (error) {
        notify(`Erro ao buscar transportadoras [${error.message}]`)
    }
}

export function* pesqNotasAcao() {
    yield takeLatest(Types.PESQ_NOTAS, pesqNotas);
}

export function* enviarEmailAcao() {
    yield takeLatest(Types.ENVIAR_EMAIL, enviarEmail);
}

export function* buscarDestAcao() {
    yield takeLatest(Types.BUSCAR_DEST, buscarDest);
}

export function* buscarTranspAcao() {
    yield takeLatest(Types.BUSCAR_TRANSP, buscarTransp);
}

export default function* rootSaga() {
    yield all([
        fork(pesqNotasAcao),
        fork(enviarEmailAcao),
        fork(buscarDestAcao),
        fork(buscarTranspAcao),
    ]);
}
